
import { IEscapador } from '@/dominio/comum/escapador/Escapador';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'EscapadoresDisponiveis',
    props: {
        escapadores: {
            type: Array,
            required: true,
        },
        escapadoresUsados: {
            type: Array,
            required: false,
        },
    },
});
